export const FontSizes = [11, 13, 16, 18, 24, 35];
export const Sizes = [0, 4, 8, 16, 32, 64, 128, 256, 512, 1024];
